"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const breadcrumb_trail_1 = require("@completeanatomy/breadcrumb-trail");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const preferences_1 = require("@completeanatomy/preferences");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const HistoryNavigation_1 = __importDefault(require("../HistoryNavigation"));
var ToolbarButtons;
(function (ToolbarButtons) {
    ToolbarButtons[ToolbarButtons["Unknown"] = 0] = "Unknown";
    ToolbarButtons[ToolbarButtons["Tabs"] = 1] = "Tabs";
    ToolbarButtons[ToolbarButtons["Home"] = 2] = "Home";
    ToolbarButtons[ToolbarButtons["Undo"] = 3] = "Undo";
    ToolbarButtons[ToolbarButtons["Redo"] = 4] = "Redo";
})(ToolbarButtons || (exports.ToolbarButtons = ToolbarButtons = {}));
function NavigationToolbar({ isFullBody, isToolsMode = false, className, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const [visible] = (0, ui_1.useToggleState)(true);
    /**
     * @todo Remove this checks when Tools and Tabs are migrated to ca-modules
     */
    const isTabsButtonAvailable = (0, preferences_1.useIsPreferenceActive)(bridge_schema_1.PreferenceBoolOption.ShowTabs);
    const isHubAvailable = (0, preferences_1.useIsPreferenceActive)(bridge_schema_1.PreferenceBoolOption.ShowHub);
    const [width, setWidth] = (0, react_1.useState)(0);
    const updateWidth = () => {
        setWidth(Math.round((window.innerWidth -
            window.innerHeight / (0.75 || window.innerHeight)) /
            2));
    };
    (0, react_1.useEffect)(() => {
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: visible, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'NavigationToolbar_CSSTransition', children: (0, jsx_runtime_1.jsx)(Wrapper, { className: className, "$hasHeader": isFullBody, "$hasTabs": isTabsButtonAvailable, "$isMobile": isMobile, "$marginToolkitMode": width, "$hasHub": isHubAvailable, "data-e2e": 'NavigationToolbar_Wrapper', children: (0, jsx_runtime_1.jsxs)(ButtonContainer, { "data-e2e": 'NavigationToolbar_ButtonContainer', children: [(0, jsx_runtime_1.jsx)(HistoryNavigation_1.default, { isToolsMode: isToolsMode, "data-e2e": 'NavigationToolbar_HistoryNavigation' }), !isToolsMode && (0, jsx_runtime_1.jsx)(breadcrumb_trail_1.BreadcrumbTrail, { "data-e2e": 'NavigationToolbar_BreadcrumbTrail' })] }) }) }));
}
exports.default = NavigationToolbar;
const Wrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  align-items: center;

  background: none;

  width: ${({ $hasTabs, $isMobile, $hasHub }) => !$isMobile
    ? `calc(100%${$hasHub && ' - 76px'}${$hasTabs && ' - 40px'})`
    : '100%'};

  margin-left: ${({ $hasTabs, $isMobile }) => $hasTabs && !$isMobile ? '40px' : '0px'};

  margin-right: ${({ $hasHub, $isMobile }) => $hasHub && !$isMobile ? '76px' : '0px'};

  pointer-events: none;

  padding-top: ${({ $hasHeader }) => $hasHeader ? 'env(safe-area-inset-top)' : '0px'};

  [toolkit-active] & {
    margin-top: ${({ $hasHeader }) => ($hasHeader ? '44px' : '0px')};
  }

  [toolkit-grids-active] & {
    margin-left: ${({ $marginToolkitMode }) => `${$marginToolkitMode}px`};
  }

  [question-editing-mode] &,
  [quiz-play-view] &,
  [quizzes-view] &,
  [screens-mode] &,
  [playing-lecture] &,
  [live-mode] &,
  [startup-hint] & {
    display: none;
  }

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    height: 30px;
    min-height: 30px;
  `)}
  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    height: 56px;
  `)}
  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 56px;
    margin-right: 76px;
  `)}
`;
const ButtonContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    height: 100%;
    margin: 6px 0 0 5px;
    align-self: flex-start;
    align-items: flex-start;
  `)}

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    height: 56px;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 56px;
    margin: 0;
    align-items: center;
  `)}

  transition: transform 0.2s ease-in-out;

  pointer-events: none;

  &.enter {
    transform: translateY(-100%);
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(-100%);
  }
`;
